import React from 'react';
import { usePostTune } from '../../hooks/usePostTune';
import { usePostIqama } from '../../hooks/usePostIqama';
import { useConditional } from '../../state/storeConditional ';

type Props = {
    label?: string;
    value?: string;
};

const Input = (props: Props) => {
    const [value, setValue] = React.useState(props.value);
    const { updateIsReadyGenerator } = useConditional();

    const { getInputTune } = usePostTune();
    const { getInputIqama } = usePostIqama();

    React.useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newData = {
            meta: e.currentTarget.name,
            value: e.currentTarget.value,
        };
        getInputTune(newData);
        getInputIqama(newData);
        setValue(e.currentTarget.value);
        updateIsReadyGenerator(true);
    };

    // Generate a unique ID based on the label prop.
    const inputId = `input-${props.label?.replace(/\s+/g, '-').toLowerCase()}`;

    return (
        <div>
            <div>{props.label}</div>
            <input
                id={inputId}
                className="!border-none !bg-white drop-shadow-c-dsh-1 cursor-pointer h-9 w-full text-base !text-green-700 px-3"
                type="number"
                name={props.label}
                onChange={handleChange}
                value={value}
            />
        </div>
    );
};

export default Input;
